// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__qEF-_","list":"PatternAutocomplete_list__3gvql"};